<template>
  <v-card
    :class="post.consumed? 'rounded-un shaddow-un mb-10 fakeLink':'rounded-un shaddow-un mb-10'"
    :color="post.consumed ? color : 'white'"
    :dark="post.consumed ? true : false"
    
  >
    <v-img
      width="100%"
      :height="$vuetify.breakpoint.mdAndUp ? '400px' : '186px'"
      :src="post.picture"
      v-if="post.picture && !post.consumed"
      @click="goTo()"
      class="fake-link"
    ></v-img>
    <v-container :class="post.consumed ? 'py-0' : ''" @click="post.consumed ? consume(post): ''">
      <v-row
        :class="classRow"
        :align="$vuetify.breakpoint.mdAndUp ? 'center' : 'start'"
        justify="center"
      >
        <v-col :cols="cols" class="text-center">
          <v-avatar size="60" class="rounded-un" :color="!post.consumed? bgcolor : color">
            <img :src="require(`@/assets/${icon}`)"  style="width:36px !important;" v-if="!post.consumed" />
            <img src="@/assets/check-circle@1,5x.svg"  style="width:24px !important;" v-if="post.consumed" />
          </v-avatar>
        </v-col>
        <v-col class="pl-8">
          <span
            :class="
              post.consumed ? 'color-white post-category font-dm' : 'post-category font-dm'
            "
            :style="!post.consumed ? 'color:' + color + '!important': ''"
            >{{ translateCategory(post.category) }}</span
          >
          <span
            @click="goTo()"
            :class="
              post.consumed
                ? 'post-title font-dm fakeLink'
                : 'post-title color-purple font-dm fakeLink'
            "
            >{{ post.title }}</span
          >
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import axios from "axios";
import { baseApiUrl } from "@/global";

export default {
  props: {
    post: Object,
  },
  computed: {
    cols() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        if (this.post.consumed) {
          return "1";
        } else {
          return "1";
        }
      } else {
        return "2";
      }
    },
    classRow() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        if (this.post.consumed) {
          return "my-5 mx-5";
        } else {
          return "my-0 mx-1 pa-0";
        }
      } else {
        return "my-0 mx-1 pa-0";
      }
    },
    bgcolor() {
      if (this.post.category === "ideias") {
        return "#e5f3fa";
      }
      if (this.post.category === "acoes") {
        return "#e5efed";
      }
      if (this.post.category === "quiz") {
        return "#ffeef6";
      }

      return "";
    },
    color() {
      if (this.post.category === "ideias") {
        return "#008FD2";
      }
      if (this.post.category === "acoes") {
        return "#006653";
      }
      if (this.post.category === "quiz") {
        return "#FF55A6";
      }

      return "";
    },
    icon() {
      if (this.post.category === "ideias") {
        return "lamp@1,5x.svg";
      }
      if (this.post.category === "acoes") {
        return "flash@1,5x.svg";
      }
      if (this.post.category === "quiz") {
        return "puzzle@1,5x.svg";
      }

      return "";
    },
  },
  methods: {
    goTo() {
      if (this.post.category !== "quiz") {
        const url = `/${this.post.category}/${this.post.id}`;
        this.$router.push(url);
      } else{
        const quiz = this.post.id.split("-")
        const url = `${baseApiUrl}/quiz/${quiz[0]}`
        
        axios.get(url).then(res => {
          this.$store.dispatch("setPopupInfo", res.data);
          this.$store.dispatch("setResetQuizInfo", true);
        })
      }
    },
    consume(item){
      if(item.consumed === true || item.category === "quiz"){
        this.goTo()
      }
    },
    translateCategory(category) {
      if (this.post.category === "ideias") {
        return "Ideias";
      }
      if (this.post.category === "acoes") {
        return "Ações";
      }
      if (this.post.category === "quiz") {
        return "Quiz";
      }

      return category;
    },
  },
  mounted(){
    // if(this.post.category === "quiz"){
    //   this.post.consumed = true
    // }
  }
};
</script>

<style></style>
